import { useEffect, useState } from "react"
import { getPhrase } from "../../shared/translation"
import { Circle } from "../assets/Circle"
import { useApp } from "../AppProvider"

const AppBottomNavPlaceholder = () => (
    <div className="app-bottom-nav with-icon-svg" style={{ minHeight: "40px" }}>
        {[...Array(5)].map((e, i) => (
            <div key={i} className="app-bottom-nav-item h-100">
                <Circle />
            </div>
        ))}
    </div>
)

export function AppBottomPlaceholder() {
    const { breakpoint } = useApp()
    const [showHelpWithLoading, setShowHelpWithLoading] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setShowHelpWithLoading(true)
        }, 3000)
    }, [])

    return (
        <div className="app-bottom" aria-hidden="true">
            {breakpoint === "lg" && <AppBottomNavPlaceholder />}

            <div className="h-100">
                <div className="overview category-overview loading-placeholder">
                    <div className="p-3">
                        {getPhrase("Loading")}
                        {showHelpWithLoading && (
                            <div>
                                {getPhrase("Having loading problems?")}{" "}
                                <a href="https://www.sp-studio.de/w/faq/help-with-loading-problems/">
                                    {getPhrase("Click here to get help")}
                                </a>
                            </div>
                        )}
                    </div>

                    {[...Array(9)].map((e, i) => (
                        <div key={i} style={{ height: "100px" }} />
                    ))}
                </div>
            </div>

            {breakpoint !== "lg" && <AppBottomNavPlaceholder />}
        </div>
    )
}
